module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_PromoGuardian01.eabf0f13.jpg";